export default __webpack_public_path__ + "static/media/w.51be8465.png";